// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Insta = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Insta = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Insta = _exports.Insta = function Insta(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M17.449 6.9078C17.3906 5.7078 17.1156 4.64114 16.2406 3.76614C15.3656 2.89114 14.299 2.61615 13.099 2.55781C11.8573 2.49115 8.14896 2.49115 6.91563 2.55781C5.71563 2.61615 4.6573 2.89114 3.77397 3.76614C2.89064 4.64114 2.62396 5.7078 2.56562 6.9078C2.49896 8.14947 2.49896 11.8578 2.56562 13.0995C2.62396 14.2995 2.89897 15.3661 3.77397 16.2411C4.6573 17.1161 5.71563 17.3911 6.91563 17.4495C8.15729 17.5161 11.8656 17.5161 13.099 17.4495C14.299 17.3911 15.3656 17.1161 16.2406 16.2411C17.1156 15.3661 17.3906 14.2995 17.449 13.0995C17.5156 11.8578 17.5156 8.14948 17.449 6.91614V6.9078ZM9.99897 13.9578C7.81564 13.9578 6.04064 12.1828 6.04064 9.99947C6.04064 7.81614 7.81564 6.04114 9.99897 6.04114C12.1823 6.04114 13.9573 7.81614 13.9573 9.99947C13.9573 12.1828 12.1823 13.9578 9.99897 13.9578ZM14.599 6.24947C14.1406 6.24947 13.7656 5.87447 13.7656 5.41614C13.7656 4.95781 14.1323 4.58281 14.599 4.58281C15.0573 4.58281 15.4323 4.95781 15.4323 5.41614C15.4323 5.87447 15.0573 6.24947 14.599 6.24947ZM12.7073 9.99947C12.7073 11.4911 11.4906 12.7078 9.99897 12.7078C8.5073 12.7078 7.29064 11.4911 7.29064 9.99947C7.29064 8.50781 8.5073 7.29114 9.99897 7.29114C11.4906 7.29114 12.7073 8.50781 12.7073 9.99947Z",
      fill: "currentColor"
    }));
  };
});
